@file:OptIn(InternalResourceApi::class)

package mifos_mobile.feature.transfer_process.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mifos_mobile.feature.transfer_process.generated.resources/"

internal val Res.string.amount: StringResource by lazy {
      StringResource("string:amount", "amount", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 22),
      ))
    }

internal val Res.string.back_to_accounts: StringResource by lazy {
      StringResource("string:back_to_accounts", "back_to_accounts", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 33, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33, 52),
      ))
    }

internal val Res.string.cancel: StringResource by lazy {
      StringResource("string:cancel", "cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 82, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86, 22),
      ))
    }

internal val Res.string.date: StringResource by lazy {
      StringResource("string:date", "date", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 109, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 109, 20),
      ))
    }

internal val Res.string.error_description: StringResource by lazy {
      StringResource("string:error_description", "error_description", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 130, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130, 85),
      ))
    }

internal val Res.string.error_icon_description: StringResource by lazy {
      StringResource("string:error_icon_description", "error_icon_description", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 216, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 216, 38),
      ))
    }

internal val Res.string.feature_make_transfer_error_amount_invalid: StringResource by lazy {
      StringResource("string:feature_make_transfer_error_amount_invalid", "feature_make_transfer_error_amount_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 255, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 255, 86),
      ))
    }

internal val Res.string.feature_make_transfer_error_amount_required: StringResource by lazy {
      StringResource("string:feature_make_transfer_error_amount_required", "feature_make_transfer_error_amount_required", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 338, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 342, 75),
      ))
    }

internal val Res.string.feature_make_transfer_error_remarks_empty: StringResource by lazy {
      StringResource("string:feature_make_transfer_error_remarks_empty", "feature_make_transfer_error_remarks_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 414, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 418, 81),
      ))
    }

internal val Res.string.feature_make_transfer_error_remarks_invalid: StringResource by lazy {
      StringResource("string:feature_make_transfer_error_remarks_invalid", "feature_make_transfer_error_remarks_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 512, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 500, 83),
      ))
    }

internal val Res.string.feature_make_transfer_error_server: StringResource by lazy {
      StringResource("string:feature_make_transfer_error_server", "feature_make_transfer_error_server", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 596, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 584, 142),
      ))
    }

internal val Res.string.make_transfer: StringResource by lazy {
      StringResource("string:make_transfer", "make_transfer", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 759, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 727, 41),
      ))
    }

internal val Res.string.pay_from: StringResource by lazy {
      StringResource("string:pay_from", "pay_from", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 809, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 769, 28),
      ))
    }

internal val Res.string.pay_to: StringResource by lazy {
      StringResource("string:pay_to", "pay_to", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 842, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 798, 34),
      ))
    }

internal val Res.string.remark: StringResource by lazy {
      StringResource("string:remark", "remark", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 909, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 861, 22),
      ))
    }

internal val Res.string.remarks: StringResource by lazy {
      StringResource("string:remarks", "remarks", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 877, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 833, 27),
      ))
    }

internal val Res.string.transfer: StringResource by lazy {
      StringResource("string:transfer", "transfer", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1246, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1150, 28),
      ))
    }

internal val Res.string.transfer_failed: StringResource by lazy {
      StringResource("string:transfer_failed", "transfer_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 940, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 884, 43),
      ))
    }

internal val Res.string.transfer_from_savings: StringResource by lazy {
      StringResource("string:transfer_from_savings", "transfer_from_savings", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 992, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 928, 57),
      ))
    }

internal val Res.string.transfer_id_prefix: StringResource by lazy {
      StringResource("string:transfer_id_prefix", "transfer_id_prefix", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1070, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 986, 42),
      ))
    }

internal val Res.string.transfer_successful: StringResource by lazy {
      StringResource("string:transfer_successful", "transfer_successful", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1129, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1029, 55),
      ))
    }

internal val Res.string.transferred_successfully: StringResource by lazy {
      StringResource("string:transferred_successfully", "transferred_successfully", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1185, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1085, 64),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("amount", Res.string.amount)
  map.put("back_to_accounts", Res.string.back_to_accounts)
  map.put("cancel", Res.string.cancel)
  map.put("date", Res.string.date)
  map.put("error_description", Res.string.error_description)
  map.put("error_icon_description", Res.string.error_icon_description)
  map.put("feature_make_transfer_error_amount_invalid", Res.string.feature_make_transfer_error_amount_invalid)
  map.put("feature_make_transfer_error_amount_required", Res.string.feature_make_transfer_error_amount_required)
  map.put("feature_make_transfer_error_remarks_empty", Res.string.feature_make_transfer_error_remarks_empty)
  map.put("feature_make_transfer_error_remarks_invalid", Res.string.feature_make_transfer_error_remarks_invalid)
  map.put("feature_make_transfer_error_server", Res.string.feature_make_transfer_error_server)
  map.put("make_transfer", Res.string.make_transfer)
  map.put("pay_from", Res.string.pay_from)
  map.put("pay_to", Res.string.pay_to)
  map.put("remark", Res.string.remark)
  map.put("remarks", Res.string.remarks)
  map.put("transfer", Res.string.transfer)
  map.put("transfer_failed", Res.string.transfer_failed)
  map.put("transfer_from_savings", Res.string.transfer_from_savings)
  map.put("transfer_id_prefix", Res.string.transfer_id_prefix)
  map.put("transfer_successful", Res.string.transfer_successful)
  map.put("transferred_successfully", Res.string.transferred_successfully)
}
